import type { PublicOffering, PublicVenue, Venue } from './domain'

export const defaultVenueImage = 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=2000&q=88'

export function toBookingVenue(venue: PublicVenue, offering: PublicOffering, fallbackMarket = 'Location unavailable'): Venue {
  return {
    id: offering.id,
    name: venue.publicName,
    neighborhood: venue.neighborhood || venue.market || fallbackMarket,
    image: offering.imageUrls?.[0] || venue.imageUrl || defaultVenueImage,
    timezone: venue.timezone,
    offeringName: offering.name,
    offeringContext: {
      discoveryTag: offering.discoveryTag,
      campaignTag: offering.campaignTag,
      outdoor: offering.outdoor,
      sameBusinessLocation: offering.sameBusinessLocation,
      addressOverride: offering.sameBusinessLocation === false ? offering.addressOverride : undefined,
      address2: offering.address2,
    },
    partyMin: offering.partyMin,
    partyMax: offering.partyMax,
    fees: offering.fees,
    menu: offering.menu,
    tables: {
      tenantSlug: venue.tenantSlug,
      locationSlug: venue.locationSlug,
      experienceId: offering.id,
      accessToken: venue.accessToken,
    },
  }
}
